import React from 'react';
import { useRemainingWidth, useWidth, WidthProvider } from '../width-context';
import { SectionSimple } from './section-simple';
import { SectionFullWidth } from './section-full-width';
export function Section(props) {
    const { backgroundColor, borderBottom, borderLeft, borderRight, borderTop, children, cssClass, direction = 'ltr', fullWidth, padding = '20px 0', textAlign = 'center', } = props;
    const { width } = useWidth();
    const remainingWidth = useRemainingWidth({
        padding,
        borderLeft,
        borderRight,
    });
    const simpleSection = (React.createElement(SectionSimple, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: cssClass, direction: direction, padding: padding, textAlign: textAlign, width: width, fullWidth: fullWidth },
        React.createElement(WidthProvider, { value: remainingWidth }, children)));
    if (fullWidth) {
        return (React.createElement(SectionFullWidth, { cssClass: cssClass, backgroundColor: backgroundColor }, simpleSection));
    }
    return simpleSection;
}
//# sourceMappingURL=section.js.map